module.exports = __webpack_public_path__ + "7586f2f6827e1b9189f38e2508cec644.svg";